import { AdvancedSearchTypes, FavouriteDefinition } from 'app/types-shared';
import { Filter, FilterDomains, FilterDomainNode } from 'app/components/filters/types';
import { FilterTypes } from 'app/components/filters/types';
import { groupConditions } from 'app/area/filters/favourite-definition/group-conditions';
import { mapInitialConditions } from 'app/area/filters/favourite-definition/map-initial-conditions';
import { mapOptionType } from 'app/area/filters/favourite-definition/map-option-type';
import { mapMenuOptions } from 'app/area/filters/favourite-definition/map-to-filters';

let filtersIdCounter = 1;

const advancedField = (advancedSearchTypes: AdvancedSearchTypes[], filterType: FilterTypes) =>
  advancedSearchTypes.find(item => item.id.v === filterType);

export const createReportDefinition = (
  definition: Partial<FavouriteDefinition>,
  filterDomains: FilterDomainNode[],
  advancedSearchTypes: AdvancedSearchTypes[],
  predefDate: Date,
  predefinedLabel: string,
  open: boolean = false): Filter[] => {

  const initialFilter = (filterDomain: number) => {
    return {
      id: filterDomain + '_' + (filtersIdCounter++),
      initialValue: undefined,
      conditions: [],
      menuOptions: [],
      optionType: undefined,
      subOptionTypes: [],
      isOpen: true,
      required: undefined
    };
  };

  const predefinedFilter: Filter = {
    id: FilterDomains.PredefDate + '_' + (filtersIdCounter++),
    domain: FilterDomains.PredefDate,
    label: predefinedLabel,
    advancedSearchType: FilterTypes.PredefDate,
    advancedField: advancedField(advancedSearchTypes, FilterTypes.PredefDate),
    initialValue: predefDate,
    conditions: [],
    menuOptions: [],
    optionType: undefined,
    subOptionTypes: [],
    sequence: 0,
    isOpen: open,
    searchRequired: undefined,
    required: true
  };

  const emptyFilters: Filter[] = filterDomains.map(f => ({
    id: f.domain + '_' + (filtersIdCounter++),
    domain: f.domain,
    label: f.label,
    advancedSearchType: f.advancedSearchType,
    advancedField: advancedField(advancedSearchTypes, f.advancedSearchType),
    initialValue: undefined,
    conditions: [],
    menuOptions: [],
    optionType: undefined,
    subOptionTypes: [],
    sequence: f.sequence,
    isOpen: open,
    searchRequired: f.searchRequired,
    required: f.required
  }));

  // Creates list of filters based on favourite definition
  const newFilters: Filter[] = !!definition ?
    groupConditions(definition.conditions)
      .map(conditions => {
        const condition = conditions[0];
        const filterDomain = filterDomains.filter(f=>f.domain === condition.domain.v)[0];
        return {
          ...initialFilter(condition.domain.v),
          domain: condition.domain.v,
          label: !!condition.domain.ald ? condition.domain.ald : condition.domain.d,
          advancedSearchType: condition.advancedSearchType,
          initialValue: mapInitialConditions(conditions),
          menuOptions: mapMenuOptions(condition),
          optionType: mapOptionType(condition),
          searchRequired: condition.searchRequired,
          advancedField: advancedField(advancedSearchTypes, condition.advancedSearchType),
          required: filterDomain?.required,
          conditions
        } as Filter;
      })
    : [];

  // Replaces empty filters with the one created based on favourite for the same domain
  const conditionFilters = [...emptyFilters, ...newFilters].reduce((memo, filter) => {
    const placeholderIndex = memo.findIndex(f => f.domain === filter.domain && !f.initialValue);

    if (placeholderIndex !== -1) {
      memo.splice(placeholderIndex, 1, filter);
      return memo;
    }
    return [...memo, filter];
  }, [] as Filter[]);

  return [
    predefinedFilter,
    ...conditionFilters
  ].sort((a, b) => a.sequence - b.sequence);
};
